import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCustomer } from 'services/CustomerService'

export const useCustomerQuery = <CustomerDetails extends object>(id: string) => {
  return useQuery({
    queryKey: reactQueryKeys.customer(id),
    queryFn: () => getCustomer<CustomerDetails>(id),
    enabled: !!id,
  })
}
